module.exports = __webpack_public_path__ + "img/visa.39024552.png";